/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/6FEMNOLL/"

const sixFemnoll: CommunityData = {
  code: "6femnoll",
  inviteCode: "6femnoll",
  name: "6femnoll",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/6femnoll`,
  socials: {},
  styles: {
    global: {
      counterColor: "#fffce5",
      logo: {
        src: `https://media.werz.at/community-assets/6FEMNOLL/web-logo.png`,
        styles: "w-[260px] h-[61px]",
      },
      alternativeLogo: {
        src: `https://media.werz.at/community-assets/6FEMNOLL/web-alternative-logo.png`,
        styles: "w-[170px] h-[50px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#242424",
      asideBg: "#242424",
      asideStyles: "border-r border-[#6D6D6D]",
      contentBg: "#242424",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background.mp4?type=video`,
      mainFont: "font-['LibreFranklinRegular']",
      primaryButton:
        "bg-[#242424] border border-[#fffce5] rounded-lg px-6 py-4 !text-[#fffce5] font-['BebasNeueRegular'] !text-[26px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#fffce5",
      sideBarSeparator: "",
      separator: "",
      item: "font-['BebasNeueRegular'] text-[22px] text-[#fffce5] text-left text-center -ml-2 border-b border-[#fffce5] text-opacity-50",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#242424] !pb-8",
      titles:
        "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#fffce5]",
        sectionTitle:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-[326px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#fffce5] font-['BebasNeueRegular'] text-[26px] uppercase text-left leading-[100%]",
          subtitle: "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#fffce5]",
        sectionTitle:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#fffce5] font-['BebasNeueRegular'] text-[22px] uppercase text-left leading-[100%]",
          subtitle: "text-[#fffce5] font-['LibreFranklinRegular'] text-[12px] text-left mt-2",
          location: "text-[#fffce5] font-['LibreFranklinRegular'] text-[12px] text-left mt-2",
          date: "text-[#fffce5] font-['LibreFranklinRegular'] text-[12px] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[34px] uppercase text-left leading-[100%]",
        text: "text-[#fffce5] font-['LibreFranklinRegular'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[34px] uppercase text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#242424] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left mb-4 text-[#fffce5]",
        button:
          "bg-[#242424] border border-[#fffce5] rounded-lg px-6 py-4 !w-fit mb-4 sm:mb-0 text-[#fffce5] font-['BebasNeueRegular'] !text-[26px] uppercase text-left",
        questions: "text-[14px] text-left text-[#fffce5]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#fffce5] border-t",
        header:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%]",
        text: "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#fffce5] border-t",
        header:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[34px] uppercase text-left leading-[100%]",
        text: "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#fffce5",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%]",
        text: "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#fffce5] font-['BebasNeueRegular'] text-[36px] uppercase text-left leading-[100%] border-t border-[#fffce5] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#242424] ",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#fffce5] border border-[#fffce5] rounded-lg px-4 py-3 text-[#000000] font-['LibreFranklinRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#242424] border-b border-[#fffce5] py-4",
          media: "!hidden",
          name: "text-[#fffce5] font-['BebasNeueRegular'] text-[22px] uppercase text-left leading-[100%]",
          description:
            "text-[#fffce5] font-['LibreFranklinRegular'] text-[14px] text-left flex flex-row gap-1",
          price:
            "text-[#fffce5] font-['BebasNeueRegular'] text-[22px] uppercase text-left leading-[100%]",
          quantity: "text-[#000000] font-['LibreFranklinRegular'] text-[14px] text-left",
          status:
            "text-[#fffce5] font-['BebasNeueRegular'] text-[22px] uppercase text-left leading-[100%]",
          counterContainer:
            "bg-[#fffce5] border border-[#fffce5] rounded-lg px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#fffce5] border border-[#fffce5] rounded-lg px-4 py-3 text-[#000000] font-['LibreFranklinRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default sixFemnoll
